module.exports = __webpack_public_path__ + "img/securitydetailsLogo1.b917b4d2.png";